import {BehaviorSubject} from 'rxjs';
import axios from 'axios';
import {handleResponse, utilHelper} from "../../_helpers";

const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));
currentUserSubject.subscribe();

export const authenticationService = {
    login,
    logout,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() {
        return currentUserSubject.value
    }
};

function login(username, password) {

    return axios({
        method: 'POST',
        url: utilHelper.baseEndPoint() + 'api/login',
        data: {username, password}
    })
        .then(handleResponse)
        .then(user => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(user));
            currentUserSubject.next(user);
            return user;
        })
        .catch(function (error) {
            console.log(error);
        });
}

function logout() {
    return utilHelper.doRequest('api/logout', 'POST')
        .then((response) => {
            localStorage.clear();
            currentUserSubject.next(null);
        });
}
